module.exports = __webpack_public_path__ + "static/img/defaultImg.38342f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/swipe/defaultImg.png
// module id = LGnN
// module chunks = 1